import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  myStatsData: {},
  pointsThisWeek: null,
  rank: null,
  pointsThisWeekWaiting: false,
});

const reducer = function myStatsReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_STATS:
      return state.set('myStatsData', action.statsData);
    case t.SET_POINTS_THIS_WEEK_WAITING:
      return state.set('pointsThisWeekWaiting', action.value);
    case t.SET_POINTS_THIS_WEEK:
      return state
        .set('pointsThisWeek', action.data.pointsThisWeek)
        .set('rank', action.data.rank);
    default:
      return state;
  }
};

export default reducer;
